module.exports = __webpack_public_path__ + "static/media/greater.d56e7b75.svg";